import type { UseMutationOptions, UseMutationResult } from "react-query";
import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

type Args = { patientID: number };

export const usePostStartTreatment = (
  args: Args,
  options?: UseMutationOptions<null, Error, Args>
): UseMutationResult<null, Error, Args> => {
  const client = useApiClient();

  return useMutation(({ patientID }) => {
    return client.postStartTreatment(patientID);
  }, options);
};
